const checkPath = (location, path) => {
  if (location.pathname.includes(path)) return true;
  return false;
};

export { checkPath };
